import { render } from "./PremiumView.vue?vue&type=template&id=daba49ac"
import script from "./PremiumView.vue?vue&type=script&lang=js"
export * from "./PremiumView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__